import styles from './style.module.scss';
import { List, Divider } from 'antd';
import { PageHeader } from 'components';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useLogs from '../useLogs';

const SingleLog = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { singleData, loading } = useLogs(false, id);

  const dataKeys = [
    { key: 'name', text: t('Utente') },
    { key: 'email', text: t('Email') },
    { key: 'request_type', text: t('Tipo') },
    { key: 'request_url', text: t('Request url') },
    { key: 'title', text: t('Parameters') },
    { key: 'remote_ip', text: t('IP') },
    { key: 'created_at', text: t('Created') },
  ];

  return (
    <div>
      <PageHeader title={''} />
      <div className={styles.content}>
        <List
          loading={loading}
          dataSource={dataKeys}
          renderItem={(item) => (
            <List.Item>
              <b className={styles.itemName}>{item.text}</b>
              {singleData[item.key]}
            </List.Item>
          )}
        />
        <Divider />
      </div>
    </div>
  );
};

export default SingleLog;
